import {
  findParticipantOnboardingDetailsByOnboardingDetailsId,
  findParticipantOnboardingDetailsByRole,
  getOnboardingDetailsIdFromLocation,
  getParticipantRoleByQueryParam,
} from "../participants";

export const LoanMapper = {
  hydrate(loanData) {
    // Publish loan status to parent
    const loanStatus = loanData.status;
    window.parent.postMessage(
      { messageId: "loanStatus", payload: { status: loanStatus } },
      "*"
    );

    const onboardingDetailsId = getOnboardingDetailsIdFromLocation();
    const participantRole = getParticipantRoleByQueryParam(loanData);

    const mainOnBoardingDetails =
      (onboardingDetailsId
        ? findParticipantOnboardingDetailsByOnboardingDetailsId(
            loanData,
            onboardingDetailsId
          )
        : findParticipantOnboardingDetailsByRole(loanData, participantRole)) ??
      loanData.onboarding_details[0];

    return {
      ...loanData,
      borrower_invitation: {
        ...mainOnBoardingDetails?.invitation,
      },
      borrower_user_details_on_origination:
        mainOnBoardingDetails.user_details && {
          document_id: mainOnBoardingDetails.user_details.document_id,
          familiar_situation_details:
            mainOnBoardingDetails.user_details.familiar_situation_details,
          main_residence_details:
            mainOnBoardingDetails.user_details.main_residence_details,
          professional_details:
            mainOnBoardingDetails.user_details.professional_details,
        },
      borrower_bank_reader_id: mainOnBoardingDetails.borrower_bank_reader_id,
      origination_risk_values_id:
        mainOnBoardingDetails.origination_risk_values_id,
      declared_income_id: mainOnBoardingDetails.declared_income_id,
    };
  },
};
